import { AnyAction } from 'redux';

import { companySignInAction } from 'domain/companies';

import * as A from './actions';
import { BankFeedStateFactory, BankFeedUserPermissionsFactory } from './helpers';
import { BankFeedState } from './types';

export const reducer = {
  bankFeed(state: BankFeedState = BankFeedStateFactory(), action: AnyAction) {
    switch (action.type) {
      case companySignInAction.request:
        return state.set('userPermissions', BankFeedUserPermissionsFactory()).set('userPermissionsLoaded', false);

      case A.setUserPermissionsAction.type:
        return state.set('userPermissions', action.payload).set('userPermissionsLoaded', true);

      default:
        return state;
    }
  },
};
